"use client"
import { Component } from "@/types/types"
import { Stack } from "@/ui/atoms/layout/Stack"
import { GoogleAnalyticsLoader } from "@/ui/loaders/GoogleAnalyticsLoader"
import { OneTrustLoader } from "@/ui/loaders/OneTrustLoader"
import { NotificationCardsManager } from "@/ui/managers/NotificationCardsManager"
import { ReactQueryProvider } from "@/ui/providers/ReactQueryProvider"
import { ServiceStatusProvider } from "@/ui/providers/ServiceStatusProvider"
import { GlobalFooter } from "@/ui/views/global/GlobalFooter"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "globalWrapper"

export interface Props extends Component {
  showGlobalHeader?: boolean
  assetsBucket: string
  gaMeasurementId: string
}

export function GlobalWrapper({
  className = "",
  children,
  testId = COMPONENT_NAME,
  assetsBucket,
  gaMeasurementId,
}: Props) {
  return (
    <ReactQueryProvider>
      <ServiceStatusProvider assetsBucket={assetsBucket}>
        <div
          className={cx(
            "min-w-[320px] min-h-screen text-text bg-background flex flex-col grow",
            className,
          )}
          data-test={testId}
        >
          <Stack className="grow">{children}</Stack>
          <GlobalFooter />
        </div>
      </ServiceStatusProvider>
      <GoogleAnalyticsLoader gaMeasurementId={gaMeasurementId} />
      <OneTrustLoader />
      <NotificationCardsManager />
    </ReactQueryProvider>
  )
}
